import React from 'react';

// @ts-ignore
import PageWrapper from 'components/PageWrapper';
import './styles.scss';

interface Props {
    children: React.ReactElement;
}

const SubnavigationBarComponent = ({ children }: Props): React.ReactElement => (
    <div className="SubnavigationBar">
        <PageWrapper top={5} bottom={5}>
            {children}
        </PageWrapper>
    </div>
);

export default SubnavigationBarComponent;
